import * as APPROVALSTRATEGIES from './approvalStrategies.constants';
import { IApprovalStrategy } from '../../models';

/** LOAD */
export function loadApprovalStrategy() {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_LOAD };
}

export function loadApprovalStrategySuccess(data: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_LOAD_SUCCESS, payload: data };
}

export function loadApprovalStrategyError(error: any) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_LOAD_ERROR, payload: error };
}

export function loadApprovalStrategies() {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD };
}

export function loadApprovalStrategiesSuccess(data: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD_SUCCESS, payload: data };
}

export function loadApprovalStrategiesError(error: any) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD_ERROR, payload: error };
}


/** ADD */
export function addApprovalStrategy(targetApprovalStrategy: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD, payload: targetApprovalStrategy };
}

export function addApprovalStrategySuccess(targetApprovalStrategy: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD_SUCCESS, payload: targetApprovalStrategy };
}

export function addApprovalStrategyError(error: any) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateApprovalStrategy(targetApprovalStrategy: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE, payload: targetApprovalStrategy };
}

export function updateApprovalStrategySuccess(targetApprovalStrategy: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE_SUCCESS, payload: targetApprovalStrategy };
}

export function updateApprovalStrategyError(error: any) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteApprovalStrategy(guids: string[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE, payload: guids };
}

export function deleteApprovalStrategySuccess(ApprovalStrategy: IApprovalStrategy[]) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE_SUCCESS, payload: ApprovalStrategy };
}

export function deleteApprovalStrategyError(error: any) {
    return { type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE_ERROR, payload: error };
}